import { data } from "autoprefixer";
import {
    GET_ALERT_LOG_COUNT_BY_INTEGRATION_TYPE,
    GET_ALERT_LOG_COUNT_BY_INTEGRATION_TYPE_FAIL,
    GET_ALERT_LOG_COUNT_BY_INTEGRATION_TYPE_SUCCESS,
    GET_ALERT_LOG_COUNT_BY_APPLICATION_SERVICE,
    GET_ALERT_LOG_COUNT_BY_APPLICATION_SERVICE_FAIL,
    GET_ALERT_LOG_COUNT_BY_APPLICATION_SERVICE_SUCCESS,
    GET_MOST_FREQUENT_ALERTS,
    GET_MOST_FREQUENT_ALERTS_SUCCESS,
    GET_MOST_FREQUENT_ALERTS_FAIL,
    GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES,
    GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES_SUCCESS,
    GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES_FAIL,
    GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES_COUNT,
    GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES_COUNT_SUCCESS,
    GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES_COUNT_FAIL,
    GET_MOST_FREQUENT_ALERTS_AZURE_SUCCESS,
    GET_MOST_FREQUENT_ALERTS_AZURE_FAIL,
    GET_MOST_FREQUENT_ALERTS_AZURE,
    GET_MOST_FREQUENT_ALERTS_GCP,
    GET_MOST_FREQUENT_ALERTS_GCP_SUCCESS,
    GET_MOST_FREQUENT_ALERTS_GCP_FAIL,
    GET_MOST_FREQUENT_ALERTS_NEW_RELIC,
    GET_MOST_FREQUENT_ALERTS_NEW_RELIC_SUCCESS,
    GET_MOST_FREQUENT_ALERTS_NEW_RELIC_FAIL,
    GET_MOST_FREQUENT_ALERTS_CLOUDWATCH,
    GET_MOST_FREQUENT_ALERTS_CLOUDWATCH_SUCCESS,
    GET_MOST_FREQUENT_ALERTS_CLOUDWATCH_FAIL,
    GET_MOST_FREQUENT_ALERTS_DATADOG,
    GET_MOST_FREQUENT_ALERTS_DATADOG_SUCCESS,
    GET_MOST_FREQUENT_ALERTS_DATADOG_FAIL,
    GET_MOST_FREQUENT_OTHER_ALERTS,
    GET_MOST_FREQUENT_OTHER_ALERTS_SUCCESS,
    GET_MOST_FREQUENT_OTHER_ALERTS_FAIL,
    GET_MOST_FREQUENT_ALERTS_OPEN_AND_CLOSE_WITHIN_5_MINUTES,
    GET_MOST_FREQUENT_ALERTS_OPEN_AND_CLOSE_WITHIN_5_MINUTES_SUCCESS,
    GET_MOST_FREQUENT_ALERTS_OPEN_AND_CLOSE_WITHIN_5_MINUTES_FAIL,
    ACCEPT_THE_SUGGESTION,
    ACCEPT_THE_SUGGESTION_SUCCESS,
    ACCEPT_THE_SUGGESTION_FAIL

} from "./actionTypes";

export const getAlertLogCountByIntegrationType = (teamIds) => ({
    type: GET_ALERT_LOG_COUNT_BY_INTEGRATION_TYPE,
    payload: {teamIds}
})

export const getAlertLogCountByIntegrationTypeSuccess = alertLogCountIntegrationType => ({
    type: GET_ALERT_LOG_COUNT_BY_INTEGRATION_TYPE_SUCCESS,
    payload: alertLogCountIntegrationType,
})

export const getAlertLogCountByIntegrationTypeFail = error => ({
    type: GET_ALERT_LOG_COUNT_BY_INTEGRATION_TYPE_FAIL,
    payload: error,
})

export const getAlertLogCountByApplicationService = (teamIds) => ({
    type: GET_ALERT_LOG_COUNT_BY_APPLICATION_SERVICE,
    payload: {teamIds}
})

export const getAlertLogCountByApplicationServiceSuccess = alertLogCountApplicationService => ({
    type: GET_ALERT_LOG_COUNT_BY_APPLICATION_SERVICE_SUCCESS,
    payload: alertLogCountApplicationService,
})

export const getAlertLogCountByApplicationServiceFail = error => ({
    type: GET_ALERT_LOG_COUNT_BY_APPLICATION_SERVICE_FAIL,
    payload: error,
})

export const getMostFrequentAlerts = (teamIds) => ({
    type: GET_MOST_FREQUENT_ALERTS,
    payload: {teamIds}
})

export const getMostFrequentAlertsSuccess = mostFrequentAlerts => ({
    type: GET_MOST_FREQUENT_ALERTS_SUCCESS,
    payload: mostFrequentAlerts,
})

export const getMostFrequentAlertsFail = error => ({
    type: GET_MOST_FREQUENT_ALERTS_FAIL,
    payload: error,
})

export const getAlertOpenAndCloseWithin5Minutes = (page_filters) => ({
    type: GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES,
    payload: { page_filters }
})

export const getAlertOpenAndCloseWithin5MinutesSuccess = alertOpenAndCloseWithin5Minutes => ({
    type: GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES_SUCCESS,
    payload: alertOpenAndCloseWithin5Minutes,
})

export const getAlertOpenAndCloseWithin5MinutesFail = error => ({
    type: GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES_FAIL,
    payload: error,
})

export const getAlertOpenAndCloseWithin5MinutesCount = (page_filters) => ({
    type: GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES_COUNT,
    payload:{page_filters}
})

export const getAlertOpenAndCloseWithin5MinutesCountSuccess = alertOpenAndCloseWithin5MinutesCount => ({
    type: GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES_COUNT_SUCCESS,
    payload: alertOpenAndCloseWithin5MinutesCount,
})

export const getAlertOpenAndCloseWithin5MinutesCountFail = error => ({
    type: GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES_COUNT_FAIL,
    payload: error,
})

export const getMostFrequentAlertsAzure = (page_filters) => ({
    type: GET_MOST_FREQUENT_ALERTS_AZURE,
    payload:{page_filters}
})

export const getMostFrequentAlertsAzureSuccess = mostFrequentAlertsAzure => ({
    type: GET_MOST_FREQUENT_ALERTS_AZURE_SUCCESS,
    payload: mostFrequentAlertsAzure,
})

export const getMostFrequentAlertsAzureFail = error => ({
    type: GET_MOST_FREQUENT_ALERTS_AZURE_FAIL,
    payload: error,
})

export const getMostFrequentAlertsGcp = (page_filters) => ({
    type: GET_MOST_FREQUENT_ALERTS_GCP,
    payload:{page_filters}
})

export const getMostFrequentAlertsGcpSuccess = mostFrequentAlertsGcp => ({
    type: GET_MOST_FREQUENT_ALERTS_GCP_SUCCESS,
    payload: mostFrequentAlertsGcp,
})

export const getMostFrequentAlertsGcpFail = error => ({
    type: GET_MOST_FREQUENT_ALERTS_GCP_FAIL,
    payload: error,
})

export const getMostFrequentAlertsNewRelic = (page_filters) => ({
    type: GET_MOST_FREQUENT_ALERTS_NEW_RELIC,
    payload:{page_filters}
})

export const getMostFrequentAlertsNewRelicSuccess = mostFrequentAlertsNewRelic => ({
    type: GET_MOST_FREQUENT_ALERTS_NEW_RELIC_SUCCESS,
    payload: mostFrequentAlertsNewRelic,
})

export const getMostFrequentAlertsNewRelicFail = error => ({
    type: GET_MOST_FREQUENT_ALERTS_NEW_RELIC_FAIL,
    payload: error,
})

export const getMostFrequentAlertsAws = (page_filters) => ({
    type: GET_MOST_FREQUENT_ALERTS_CLOUDWATCH,
    payload:{page_filters}
})

export const getMostFrequentAlertsAwsSuccess = mostFrequentAlertsAws => ({
    type: GET_MOST_FREQUENT_ALERTS_CLOUDWATCH_SUCCESS,
    payload: mostFrequentAlertsAws,
})

export const getMostFrequentAlertsAwsFail = error => ({
    type: GET_MOST_FREQUENT_ALERTS_CLOUDWATCH_FAIL,
    payload: error,
})

export const getMostFrequentAlertsDataDog = (page_filters) => ({
    type: GET_MOST_FREQUENT_ALERTS_DATADOG,
    payload:{page_filters}
})

export const getMostFrequentAlertsDataDogSuccess = mostFrequentAlertsDataDog => ({
    type: GET_MOST_FREQUENT_ALERTS_DATADOG_SUCCESS,
    payload: mostFrequentAlertsDataDog,
})

export const getMostFrequentAlertsDataDogFail = error => ({
    type: GET_MOST_FREQUENT_ALERTS_DATADOG_FAIL,
    payload: error,
})

export const getMostFrequentOtherAlerts = (page_filters) => ({
    type: GET_MOST_FREQUENT_OTHER_ALERTS,
    payload:{page_filters}
})

export const getMostFrequentOtherAlertsSuccess = mostFrequentAlertsExternalIntegrations => ({
    type: GET_MOST_FREQUENT_OTHER_ALERTS_SUCCESS,
    payload: mostFrequentAlertsExternalIntegrations,
})

export const getMostFrequentOtherAlertsFail = error => ({
    type: GET_MOST_FREQUENT_OTHER_ALERTS_FAIL,
    payload: error,
})


export const getMostFrequentAlertsOpenAndClosedWithin5Minutes = (page_filters) => ({
    type: GET_MOST_FREQUENT_ALERTS_OPEN_AND_CLOSE_WITHIN_5_MINUTES,
    payload:{page_filters}
})

export const getMostFrequentAlertsOpenAndClosedWithin5MinutesSuccess = mostFrequentAlertsOpenAndClosedWithin5Minutes => ({
    type: GET_MOST_FREQUENT_ALERTS_OPEN_AND_CLOSE_WITHIN_5_MINUTES_SUCCESS,
    payload: mostFrequentAlertsOpenAndClosedWithin5Minutes,
})

export const getMostFrequentAlertsOpenAndClosedWithin5MinutesFail = error => ({
    type: GET_MOST_FREQUENT_ALERTS_OPEN_AND_CLOSE_WITHIN_5_MINUTES_FAIL,
    payload: error,
})

export const acceptTheSuggestion = (suggestion_id) => ({
    type: ACCEPT_THE_SUGGESTION,
    payload: suggestion_id
})

export const acceptTheSuggestionSuccess = suggestion => ({
    type: ACCEPT_THE_SUGGESTION_SUCCESS,
    payload: suggestion,
})

export const acceptTheSuggestionFail = error => ({
    type: ACCEPT_THE_SUGGESTION_FAIL,
    payload: error,
})

